module.exports = __webpack_public_path__ + "officialStatic/img/mdu-detailList11.aa28d24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/mdu-detailList11.png
// module id = ZbSG
// module chunks = 0